
















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import InjuryItem from './injuryItem.vue'
import RevisitApi from '@/api/revisit'
import WholeProcessApi from '@/api/wholeProcess'
import Info from '@/views/AiiTasks/Info.vue'
import { actionColumns as columns } from './config'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])
@Component({
	name: 'WholeProcessDetail',
	components: {
		PageLayout,
		Info,
		InjuryItem,
	},
})
export default class WholeProcessDetail extends Vue {
	private data: any = {}
	private cancelForm: any = {}
	private visible = false
	private currentListData: any[] = []
	private modalLoading = false
	private isModalAdd = false
	private columns = columns
	private selectedRowKeys: string[] = []

	private get endTypeOptions() {
		return this.$store.state.setting.endTypeList.map((item: any) => {
			return {
				label: item.value,
				value: item.key,
			}
		})
	}

	private get caseInfo() {
		const baseInfo = this.data.baseInfo || {}

		return {
			title: '案件信息',
			children: [
				{
					label: '派单公司',
					value: baseInfo.companyName,
				},
				{
					label: '所属险种',
					value: this.$store.state.setting.insuranceTypeMap[
						baseInfo.insuranceType
					],
				},
				{
					label: '报案号',
					value: baseInfo.caseNo,
				},
				{
					label: '标的车牌号',
					value: baseInfo.carNo,
				},
				{
					label: '车主/报案人姓名',
					value: baseInfo.ownerName,
				},
				{
					label: '车主/报案人电话',
					value: baseInfo.ownerPhone,
				},
				{
					label: '案件负责人姓名',
					value: baseInfo.contact,
				},
				{
					label: '案件负责人电话',
					value: baseInfo.contactPhone,
				},
			],
		}
	}

	private modalReset() {
		this.cancelForm.resetFields()
		this.selectedRowKeys = []
	}

	private closeModal() {
		this.visible = false
		this.modalReset()
	}

	private onModalOk() {
		const list: any = this.currentListData || []
		if (list.length > 1) {
			const orderIdList = this.selectedRowKeys
			if (orderIdList && orderIdList.length > 0) {
				if (this.isModalAdd) {
					this.addPendingTask(orderIdList)
				} else {
					this.stopProcess(orderIdList)
				}
			} else {
				this.$message.error(
					`请先选择需要${this.isModalAdd ? '新增回访' : '终止'}的订单`
				)
			}
		} else {
			const singleOrderId = [list[0].wholeProcessOrderId]
			if (this.isModalAdd) {
				this.addPendingTask(singleOrderId)
			} else {
				this.stopProcess(singleOrderId)
			}
		}
	}

	private onRowSelect(selectedRowKeys: string[], selectedRows: any[]) {
		this.selectedRowKeys = selectedRowKeys
	}

	private showModal(listData: any[]) {
		this.visible = true
		this.currentListData = listData
	}

	private toAddPendingTask(listData: any[]) {
		this.isModalAdd = true
		this.showModal(listData)
	}

	private toStopProcess(listData: any[]) {
		this.isModalAdd = false
		this.showModal(listData)
	}

	private addPendingTask(orderIdList: string[]) {
		this.modalLoading = true
		const orderId = orderIdList && orderIdList[0]

		RevisitApi.addTrackTask(orderId)
			.then((res: any) => {
				this.$multiTab.close('/returnVisit/collectPendingInfo')
				this.$ls.set('pendingTaskId', res.data)
				this.$nextTick(() => {
					this.$multiTab.open('/returnVisit/collectPendingInfo')
				})
				// 页面跳转前关闭弹窗
				this.closeModal()
			})
			.finally(() => {
				this.modalLoading = false
			})
	}

	private stopProcess(orderIdList: string[]) {
		this.cancelForm.validateFields((errors: any, values: any) => {
			if (!errors) {
				values.orderIdList = orderIdList

				this.modalLoading = true
				WholeProcessApi.stopProcess(values)
					.then(() => {
						this.$message.success('成功结束全流程任务')
						this.closeModal()
						this.init()
					})
					.finally(() => {
						this.modalLoading = false
					})
			}
		})
	}

	private getDetail() {
		WholeProcessApi.getWPDetail(this.$route.params.id).then((res: any) => {
			const data: any = res.data || {}

			data.injuredList = data.injuredList || []
			data.injuredList.forEach((injury: any) => {
				const phones: string[] = []
				injury.targetPhone1 && phones.push(injury.targetPhone1)
				injury.targetPhone2 && phones.push(injury.targetPhone2)
				injury.targetPhone3 && phones.push(injury.targetPhone3)
				injury.injuredPhone = phones.join('、')
			})
			this.data = data
		})
	}

	private init() {
		this.getDetail()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	public activated() {
		this.init()
	}

	public created() {
		this.cancelForm = this.$form.createForm(this)
	}
}
